<template>
    <div id="toolSubscription">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">个性化工具订阅</div>
                    <div class="contentVal">
                        <span>开发者便捷小工具</span>
                        <span>与合作伙伴更好更快更便捷地对接工作</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即咨询</button>
                </div>
            </div>
        </div>
        <!--相关产品-->
        <div class="relevantProduct">
            <div class="relevantProductTitle">相关产品</div>
            <!--产品列表-->
            <div class="relevantProductListWrap">
                <!--@click="toPage('/InformationCheck')"-->
                <div class="relevantProductList" style="margin-right: 144px;cursor: not-allowed;opacity: 0.3">
                    <img src="../../assets/img/bigIcon/信息核验.png"/>
                    <span>信息核验</span>
                </div>
                <!--@click="toPage('/faceRecognition')"-->
                <div class="relevantProductList" style="margin-right: 128px;cursor: not-allowed;opacity: 0.3">
                    <img src="../../assets/img/bigIcon/人脸识别.png"/>
                    <span>人脸识别</span>
                </div>
                <div class="relevantProductList" @click="toPage('/riskWarningReport')" style="margin-right: 112px;">
                    <img src="../../assets/img/bigIcon/风控.png"/>
                    <span>风险预警报告</span>
                </div>
                <!--@click="toPage('/RiskListFiltering')"-->
                <div class="relevantProductList" style="cursor: not-allowed;opacity: 0.3">
                    <img src="../../assets/img/bigIcon/风险名单过滤.png"/>
                    <span>风险名单过滤</span>
                </div>
            </div>
        </div>
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "toolSubscription",
        data() {
            return {
                showAlertFlag: false
            }
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #toolSubscription {
        .bannerWrap {
            background: url("../../assets/img/ristWarning/个性化工具订阅banner.png") no-repeat center;
            background-color: #1D1D1D;
        }

        .relevantProduct {
            width: 704px;
        }
    }
</style>
